import CenshareStore from './store'
export const censhareStore = new CenshareStore()
